import type { GenericTranslationsObject } from '@payloadcms/translations'

export const fr: GenericTranslationsObject = {
  $schema: '../translation-schema.json',
  'plugin-redirects': {
    customUrl: 'URL personnalisée',
    documentToRedirect: 'Page de redirection',
    fromUrl: "URL d'origine",
    internalLink: 'Référence vers une page',
    redirectType: 'Type de redirection',
    toUrlType: "Type d'URL de destination",
  },
}
